import {
  Button,
  Heading,
  Box,
  Flex,
  Tooltip,
  useStyleConfig,
  EditablePreview,
  Editable, EditableTextarea,
} from '@chakra-ui/react';
import * as handlers from './handlers';
import { RiCloseCircleFill } from 'react-icons/ri';
import { DragHandleIcon } from '@chakra-ui/icons';
import SortableWrapper from '../../components/Wrappers/SortableWrapper';
import { ReactSortable } from 'react-sortablejs';
import { freeFormEdit, setSelectedBullets } from './utils';
import { getUsefulVars } from '../../handlers/helpers';
import Label from './BulletButton/Label';

const Selected = ({ jobSeekerData, props }) => {
  const uv = getUsefulVars(props);
  const classes = uv.stateProps.bulletBankStyles;
  const sectionIndex = uv.stateProps.sectionData.sectionIndex;
  const selectedBullets = uv.stateProps.bulletData.selectedBullets;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  if (selectedBullets.length === 0) {
    return (
      <Box>
        Select bullets for your resume from the Bullet Bank on the right.
      </Box>
    );
  } else {
    return (
      <Box>
        <SortableWrapper>
          <ReactSortable
            list={selectedBullets}
            setList={newState => setSelectedBullets(jobSeekerData, newState, uv.stateProps)}
            handle={".drag-handle"}
            filter={".chakra-editable__input, .chakra-editable__textarea, [contenteditable]"}
            preventOnFilter={true}
          >
            {uv.stateProps.bulletData.selectedBullets.map((option) => {
              return (
                <Box key={option.key ? option.key : option.label} sx={{ ...classes.selectedItem }}>
                  <Flex sx={{ flexDirection: 'row' }}>
                    <Tooltip
                      label="grab to re-order"
                      placement="top"
                      hasArrow
                      bg="GRAY"
                      color="WHITE"
                      fontWeight={600}
                      borderRadius={99}
                    >
                      <DragHandleIcon
                        className="drag-handle"
                        sx={{
                          color: 'ORANGE_TEXT',
                          alignSelf: 'center',
                          cursor: 'grab',
                        }}
                      />
                    </Tooltip>

                    <Box sx={{ ...classes.selectedLabelBox }}>
                      <Editable
                        sx={{
                          padding: 0,
                          margin: 0,
                          border: 'none',
                          outline: 'none',
                          background: 'transparent',
                          fontWeight: 'normal',
                        }}
                        defaultValue={option.label}
                      >
                        <EditablePreview as={Heading} variant="b16" />
                        <EditableTextarea onBlur={(e) => freeFormEdit(e, option, jobSeekerData, sectionIndex, uv.stateProps)} />
                      </Editable>
                    </Box>
                    <Box>
                      <Button
                        variant="addDel"
                        sx={{...buttonStyles.addDel }}
                        onClick={e => {
                          handlers.unSelect(jobSeekerData, option, uv.stateProps);
                          uv.stateProps.setCounter(uv.stateProps.counter + 1);
                        }}
                      >
                        <RiCloseCircleFill />
                      </Button>
                    </Box>
                  </Flex>
                </Box>
              );
            })}
          </ReactSortable>
        </SortableWrapper>
      </Box>
    );
  }
};

export default Selected;
/*

                      <button
                        onClick={e => {
                          handleRegenDirectSelected(stateProps,  bulletIndex);
                        }}>
                        <Image src="/app/images/ai.png" alt="AI" width="24px" ml="8px"
                               height="auto" />
                      </button>
 */

/*

                        <Editable
                          sx={{
                            padding: 0,
                            margin: 0,
                            border: 'none',
                            outline: 'none',
                            background: 'transparent',
                            fontWeight: 'normal',
                          }}

                          defaultValue={option.label}
                       >

                          <EditablePreview />
                          <EditableTextarea   onBlur={(e) => freeFormEdit(e,option,jobSeekerData,sectionIndex,uv.stateProps)}
                          />
                        </Editable>
 */